import { ethers } from 'ethers';

export default function parseEther(value: string) {
  try {
    return ethers.utils.parseEther(value);
  } catch (error) {
    return ethers.constants.Zero;
  }
}
